import HNSColors from "../../HNSColors";

export const getButtonsConfig = (buttons) => {
  const buttonConfig = {
    CANCEL: {
      variant: "outlined",
      sx: {
        border: "1px solid",
        backgroundColor: HNSColors.neutrals[900],
        color: HNSColors.failure[500],
        borderColor: HNSColors.failure[500],
        "&:hover": {
          backgroundColor: HNSColors.failure[700],
          color: HNSColors.failure[900],
          borderColor: HNSColors.neutrals[900],
        },
      },
    },
    DELETE: {
      sx: {
        backgroundColor: HNSColors.failure[500],
        color: HNSColors.neutrals[900],
        "&:hover": {
          backgroundColor: HNSColors.failure[600],
          color: HNSColors.neutrals[900],
        },
      },
    },
    BACK: {
      sx: {
        backgroundColor: HNSColors.secondary[500],
        color: HNSColors.neutrals[900],
        "&:hover": {
          backgroundColor: HNSColors.secondary[600],
          color: HNSColors.neutrals[900],
        },
      },
    },
    OK: {
      sx: {
        backgroundColor: HNSColors.secondary[500],
        color: HNSColors.neutrals[900],
        "&:hover": {
          backgroundColor: HNSColors.secondary[600],
          color: HNSColors.neutrals[900],
        },
      },
    },
  };

  return buttons
    .map((button) => {
      if (!buttonConfig[button?.type]) {
        return null;
      }

      return {
        label: button.label,
        onClick: button.onClick,
        ...buttonConfig[button?.type],
      };
    })
    .filter(Boolean);
};
